import { render, staticRenderFns } from "./TechServices.vue?vue&type=template&id=a08c151c&"
import script from "./TechServices.vue?vue&type=script&lang=js&"
export * from "./TechServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports